import type { Api } from "./api.types";

const direktvermarktungApiWithoutCamelization = {
  formulaAllowedVariables: {
    url: () => "/api/direktvermarktungsvertraege/allowed-variables/",
    key: () => ["direktvermarktung", "formulaAllowedVariables"]
  }
} satisfies Api;

export { direktvermarktungApiWithoutCamelization };
